import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import FormField from './FormField';
import SearchTextField from '../SearchTextField';

export default class FormSearchField extends PureComponent {
    static propTypes = {
        label: PropTypes.string,
        error: PropTypes.string,
        className: PropTypes.string,
    };
    static defaultProps = {
        label: '',
        error: null,
    };

    render() {
        const {label, error, className, ...props} = this.props;
        return (
            <FormField label={label} error={error} className={className}>
                <SearchTextField error={error} {...props}/>
            </FormField>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/controls/form/FormSearchField.js